import { Countries } from "./Types";
import { resolveTenant } from "./resolveTenant";
import { Tenant } from "./Types";

export const getCountry = (): Countries => {
	const tenant = resolveTenant();

	if (
		tenant === Tenant.NEW_LEAF ||
		tenant === Tenant.CONSOLIDATED_CREDIT_CANADA
	) {
		return "CA";
	}

	// US Consolidated Credit: hostname may still distinguish .ca legacy hosts using old tenant string.
	const regex = /\.ca$/i;
	const isCanadaUrl = regex.test(window.location.hostname);
	return isCanadaUrl ? "CA" : "US";
};
